/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpRightIcon24Regular = forwardRef('ArrowDRadiusUpRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.498 2.781a.875.875 0 1 0-1.237 1.238l5.106 5.106H12c-5.454 0-9.875 4.421-9.875 9.875v1a.875.875 0 1 0 1.75 0v-1A8.125 8.125 0 0 1 12 10.875h7.367l-5.106 5.106a.875.875 0 0 0 1.237 1.238l5.328-5.328a2.675 2.675 0 0 0 0-3.783l-5.328-5.327Z" })));
});
